import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Grid, Tooltip } from '@material-ui/core'
import NumberField from '../NumberField'

const StorageInput = ({
    title,
    tooltip,
    usage,
    onChange,
    averageYearlyStorage
}) => {
    const { cap, expectedGrowth, initialAmount } = usage
    const helperText = cap !== undefined ? 'Cap' : 'Initial amount'

    const editUsage = (callback) => {
        const u = { ...usage }
        callback(u)
        onChange(u)
    }

    return (
        <div>
            <Tooltip title={tooltip}>
                <Typography color="textSecondary">{title}</Typography>
            </Tooltip>
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={3}>
                    {cap !== undefined ? (
                        <NumberField
                            value={cap}
                            onChange={(value) =>
                                editUsage((usage) => (usage.cap = value))
                            }
                            helperText={helperText}
                        />
                    ) : (
                        <NumberField
                            value={initialAmount}
                            onChange={(value) =>
                                editUsage(
                                    (usage) => (usage.initialAmount = value)
                                )
                            }
                            helperText={helperText}
                        />
                    )}
                </Grid>
                <Grid item xs={4}>
                    <NumberField
                        value={expectedGrowth}
                        onChange={(value) =>
                            editUsage((usage) => (usage.expectedGrowth = value))
                        }
                        helperText="Growth per month"
                    />
                </Grid>
                <Grid item xs={5}>
                    <Typography variant="body1" align="center">
                        12 month avg: <b>{Math.round(averageYearlyStorage)}</b>{' '}
                        TB
                    </Typography>
                </Grid>
            </Grid>
        </div>
    )
}

StorageInput.propTypes = {
    title: PropTypes.string,
    cap: PropTypes.number,
    onChange: PropTypes.func,
    averageYearlyStorage: PropTypes.number.isRequired
}

export default StorageInput
